module.exports = __webpack_public_path__ + "media/images/164x229_shadow-0c865caa2ff114b93b08245f9d7656aa13688c4679977b7e738b6f49901e9a4b.jpg";